/* tslint:disable */
/* eslint-disable */
/**
 * Pinwheel - Main Service API
 * Pinwheel - Main Service API
 *
 * The version of the OpenAPI document: 2.85.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum FeatureEnum {
    Location = 'location',
    Contact = 'contact',
    Schedule = 'schedule',
    Mode = 'mode',
    Routine = 'routine',
    ScheduleOverride = 'scheduleOverride',
    SafelistSetting = 'safelistSetting',
    PhoneHistory = 'phoneHistory',
    App = 'app',
    PinwheelGpt = 'pinwheelGPT'
}


